import { onMounted, onUnmounted, ref } from 'vue'

const useScaling = (containerId: string, baseWidth: number = 900) => {
  const currentScale = ref(1)

  onMounted(() => {
    window.addEventListener('resize', handler)
    handler()
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handler)
  })

  const handler = (): void => {
    const containers = document.getElementsByClassName(containerId) as any

    Array.from(containers).forEach((container: any) => {
      const w = container?.clientWidth ?? baseWidth
      if (!w) return
      const scale = w / baseWidth
      currentScale.value = scale
      container && (container.style.fontSize = `${scale * 16}px`)
    })
  }
  return { scale: currentScale }
}

export { useScaling }
